module.exports = __webpack_public_path__ + "img/img2.76a80bb2.jpg";